export default function initFormUpload()
{
	const buttons = document.querySelectorAll('.form-input-file button');

	if(!buttons) return;

	buttons.forEach( (button) => {
		let fileInput = button.previousSibling;
		button.addEventListener('click', (e) => {
			e.preventDefault();
			fileInput.click();
		});
	})
}
